'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowDownTwoRectangles, iconArrowDownTwoRectanglesTag } from '@ni/nimble-components/dist/esm/icons/arrow-down-two-rectangles';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowDownTwoRectangles };
export { iconArrowDownTwoRectanglesTag };
export const NimbleIconArrowDownTwoRectangles = wrap(IconArrowDownTwoRectangles);